import React from "react";
import CommonRow from "../common-row";

const PhotoStoryWithSlider = props => {
  return <CommonRow {...props} />;
};

export default PhotoStoryWithSlider;
